import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserStore } from "./stores/userStore";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { RouteLoader } from "./components/RouteLoader";

export function GlobalContext() {
  const userStore = useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    const userChangeListener = (event: StorageEvent) => {
      if (event.key === "user") {
        if (event.newValue === null) {
          userStore.setUser(null);
        } else {
          userStore.setUser(JSON.parse(event.newValue));
        }
        navigate("/");
      }
    };

    window.addEventListener("storage", userChangeListener);

    return () => {
      window.removeEventListener("storage", userChangeListener);
    };
  }, []);

  return (
    <>
      <TooltipProvider delayDuration={500} skipDelayDuration={200}>
        <RouteLoader />
        <Outlet />
      </TooltipProvider>
      <Toaster />
    </>
  );
}
